import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { Alert } from './alert';
import { NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AlertType } from './alert-type';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private _subject = new Subject<Alert>();
  private _keepAfterRouteChange: boolean = false;

  constructor(private _router: Router) { 
    //clear alert messages on route change unless '_keepAfterRouteChange' flag is true
    _router.events.subscribe(event => {
      if(event instanceof NavigationStart) {
        if(this._keepAfterRouteChange) {
          //only keep for a single route change
          this._keepAfterRouteChange = false;
        } else {
          //clear alert message
          this.clear();
        }
      }
    })
  }

  // subscribe to alerts
  getAlert(alertId?: string): Observable<any> {
    return this._subject.asObservable().pipe(filter((x: Alert) => x && x.alertId === alertId));
  }

  //conveince methods
  success(message:string){
    this.alert(new Alert( { message, type: AlertType.Success }));
  }

  error(message: string) {
    this.alert(new Alert({ message, type: AlertType.Error }));
  }

  info(message: string) {
      this.alert(new Alert({ message, type: AlertType.Info }));
  }

  warn(message: string) {
      this.alert(new Alert({ message, type: AlertType.Warning }));
  }

  //mail alert method
  alert(alert: Alert) {
    this._keepAfterRouteChange = alert.keepAfterRouteChange;
    this._subject.next(alert); // as subject works both as observable and observer,
    // here we are pushing the alert object as observerable using next(subscribe is used for observing/observer)
  }

  //clear alerts
  clear(alertId?: string) {
    this._subject.next(new Alert( { alertId }));
  }


}
